import { SVGProps } from 'react';

export const LogOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 27 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="6"
      y="3"
      width="12"
      height="18"
      rx="1"
      fill="white"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <mask
      id="path-2-outside-1_3098_262168"
      maskUnits="userSpaceOnUse"
      x="12"
      y="6"
      width="15"
      height="11"
      fill="black"
    >
      <rect fill="white" x="12" y="6" width="15" height="11" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2197 9.28033C20.9268 8.98744 20.9268 8.51256 21.2197 8.21967C21.5126 7.92678 21.9874 7.92678 22.2803 8.21967L24.8384 10.7777C25.3754 11.3147 25.3754 12.1853 24.8384 12.7223L22.2803 15.2803C21.9874 15.5732 21.5126 15.5732 21.2197 15.2803C20.9268 14.9874 20.9268 14.5126 21.2197 14.2197L22.9393 12.5L14.9265 12.5C14.4148 12.5 14 12.1642 14 11.75C14 11.3358 14.4148 11 14.9265 11L22.9393 11L21.2197 9.28033Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.2197 9.28033C20.9268 8.98744 20.9268 8.51256 21.2197 8.21967C21.5126 7.92678 21.9874 7.92678 22.2803 8.21967L24.8384 10.7777C25.3754 11.3147 25.3754 12.1853 24.8384 12.7223L22.2803 15.2803C21.9874 15.5732 21.5126 15.5732 21.2197 15.2803C20.9268 14.9874 20.9268 14.5126 21.2197 14.2197L22.9393 12.5L14.9265 12.5C14.4148 12.5 14 12.1642 14 11.75C14 11.3358 14.4148 11 14.9265 11L22.9393 11L21.2197 9.28033Z"
      fill="currentColor"
    />
    <path
      d="M21.2197 8.21967L22.2803 9.28033L22.2803 9.28033L21.2197 8.21967ZM21.2197 9.28033L20.159 10.341L20.159 10.341L21.2197 9.28033ZM22.2803 8.21967L21.2197 9.28033L21.2197 9.28033L22.2803 8.21967ZM24.8384 10.7777L25.899 9.71707V9.71707L24.8384 10.7777ZM24.8384 12.7223L25.899 13.7829V13.7829L24.8384 12.7223ZM22.2803 15.2803L21.2197 14.2197L21.2197 14.2197L22.2803 15.2803ZM21.2197 15.2803L22.2803 14.2197L22.2803 14.2197L21.2197 15.2803ZM21.2197 14.2197L20.159 13.159L21.2197 14.2197ZM22.9393 12.5L24 13.5607L26.5607 11L22.9393 11V12.5ZM14.9265 12.5L14.9265 14H14.9265L14.9265 12.5ZM14 11.75L12.5 11.75L14 11.75ZM14.9265 11L14.9265 12.5H14.9265L14.9265 11ZM22.9393 11V12.5L26.5607 12.5L24 9.93934L22.9393 11ZM20.159 7.15901C19.2803 8.03769 19.2803 9.46231 20.159 10.341L22.2803 8.21967C22.5732 8.51256 22.5732 8.98744 22.2803 9.28033L20.159 7.15901ZM23.341 7.15901C22.4623 6.28033 21.0377 6.28033 20.159 7.15901L22.2803 9.28033C21.9874 9.57322 21.5126 9.57322 21.2197 9.28033L23.341 7.15901ZM25.899 9.71707L23.341 7.15901L21.2197 9.28033L23.7777 11.8384L25.899 9.71707ZM25.899 13.7829C27.0218 12.6602 27.0218 10.8398 25.899 9.71707L23.7777 11.8384C23.7289 11.7896 23.7289 11.7104 23.7777 11.6616L25.899 13.7829ZM23.341 16.341L25.899 13.7829L23.7777 11.6616L21.2197 14.2197L23.341 16.341ZM20.159 16.341C21.0377 17.2197 22.4623 17.2197 23.341 16.341L21.2197 14.2197C21.5126 13.9268 21.9874 13.9268 22.2803 14.2197L20.159 16.341ZM20.159 13.159C19.2803 14.0377 19.2803 15.4623 20.159 16.341L22.2803 14.2197C22.5732 14.5126 22.5732 14.9874 22.2803 15.2803L20.159 13.159ZM21.8787 11.4393L20.159 13.159L22.2803 15.2803L24 13.5607L21.8787 11.4393ZM14.9265 14L22.9393 14V11L14.9265 11L14.9265 14ZM12.5 11.75C12.5 13.2732 13.898 14 14.9265 14L14.9265 11C14.9919 11 15.0989 11.0204 15.2152 11.1145C15.3344 11.211 15.5 11.427 15.5 11.75L12.5 11.75ZM14.9265 9.5C13.898 9.5 12.5 10.2268 12.5 11.75L15.5 11.75C15.5 12.073 15.3344 12.289 15.2152 12.3855C15.0989 12.4796 14.9919 12.5 14.9265 12.5L14.9265 9.5ZM22.9393 9.5L14.9265 9.5L14.9265 12.5L22.9393 12.5V9.5ZM20.159 10.341L21.8787 12.0607L24 9.93934L22.2803 8.21967L20.159 10.341Z"
      fill="white"
      mask="url(#path-2-outside-1_3098_262168)"
    />
  </svg>
);
